import feathers from '@feathersjs/feathers';
import socketio from '@feathersjs/socketio-client';
import authClient from '@feathersjs/authentication-client';
import io from 'socket.io-client';
// or '@/libs/feathers-vuex' if you're copying feathers-vuex as mentioned earlier.
import feathersVuex from 'feathers-vuex';
import { LEVEL } from './utils/log';

// Setup the Feathers client
const host = process.env.VUE_APP_API_URL || 'http://localhost:3031/'; // or set a string here, directly
const socket = io(host, { transports: ['websocket'] });
const feathersClient = feathers()
  .configure(socketio(socket))
  .configure(authClient({ storage: window.localStorage }))
  .hooks({
    error: {
      all: [
        context => {
          const { error } = context;
          // eslint-disable-next-line no-use-before-define
          BaseModel.store.dispatch('app/pushSnack', {
            snack: _.omit(error, 'hook'),
            level: LEVEL.ERROR,
          });
          // May be useless
          return context;
        }
      ]
    }
  });

export default feathersClient;

// Setup feathers-vuex
const {
  makeServicePlugin,
  makeAuthPlugin,
  BaseModel,
  models,
  clients,
  FeathersVuex
} = feathersVuex(feathersClient, {
  serverAlias: 'api', // or whatever that makes sense for your project
  idField: '_id' // `id` and `_id` are both supported, so this is only necessary if you're using something else.
});

function makeServiceStore(options, rest) {
  return {
    [options.servicePath]: {
      namespaced: true,

      ...(rest || {}),
    }
  };
}

export {
  makeAuthPlugin,
  makeServicePlugin,
  makeServiceStore,
  BaseModel,
  models,
  clients,
  FeathersVuex
};
